import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { ContentHolder } from "commons";
import { useComponentState } from "commons/src/helpers/CustomHooks";

import { ClientAccountDetails } from "./ClientAccountDetails";
import { ContactDetails } from "./ContactDetails";
import { PersonalDetails } from "./PersonalDetails";
import { BankAccounts } from "./BankAccounts";
import { Addresses } from "./Addresses";
import { EmailAddresses } from "./EmailAddresses";
import { requestObject } from "../../reducers/requestsActions";
import { ERROR as ERROR_SEVERITY, INFO as INFO_SEVERITY } from "../../helpers/ErrorHelpers";
import { Message } from "../../components/Message";

function PersonalDetailsContainerComponent({
    addresses,
    addressesRequestStatus,
    bankAccounts,
    bankAccountsRequestStatus,
    currentUser,
    emailAddresses,
    emailAddressesRequestStatus
}) {
    const [currentState, changeStateTo, { DEFAULT, ERROR, SUCCESS }] = useComponentState();
    const [message, setMessage] = useState("");

    const location = useLocation();

    useEffect(() => {
        if (location?.state) {
            const { message, severity } = location.state;
            setMessage(message);

            if (!severity) {
                changeStateTo(DEFAULT);
            } else {
                changeStateTo(severity === ERROR ? ERROR : SUCCESS);
            }
        }
    }, [changeStateTo, location, DEFAULT, ERROR, SUCCESS]);

    return (
        <ContentHolder>
            <Message
                shown={currentState === SUCCESS || currentState === ERROR}
                text={message}
                severity={currentState === ERROR ? ERROR_SEVERITY : INFO_SEVERITY}
            />
            <PersonalDetails details={currentUser} />
            <ContactDetails
                homePhone={currentUser.homePhone}
                mobilePhone={currentUser.mobilePhone}
                businessPhone={currentUser.businessPhone}
            />
            <EmailAddresses
                emailAddresses={emailAddresses}
                requestStatus={emailAddressesRequestStatus}
            />
            <Addresses addresses={addresses} requestStatus={addressesRequestStatus} />
            <ClientAccountDetails
                clientId={currentUser.clientId}
                fsaCategory={currentUser.fsaCategory}
            />
            <BankAccounts bankAccounts={bankAccounts} requestStatus={bankAccountsRequestStatus} />
        </ContentHolder>
    );
}

PersonalDetailsContainerComponent.propTypes = {
    currentUser: PropTypes.object,
    bankAccounts: PropTypes.object,
    dispatch: PropTypes.func,
    emailAddresses: PropTypes.array,
    addresses: PropTypes.array,
    emailAddressesRequestStatus: requestObject,
    addressesRequestStatus: requestObject,
    bankAccountsRequestStatus: requestObject
};

const mapStateToProps = state => ({
    currentUser: state.user.currentUser,
    emailAddresses: state.addresses.emailAddresses,
    addresses: state.addresses.addresses,
    bankAccounts: {
        accounts: state.bankAccounts.accounts
    },
    emailAddressesRequestStatus: state.requests.emailAddresses,
    addressesRequestStatus: state.requests.addresses,
    bankAccountsRequestStatus: state.requests.bankAccounts
});

export const PersonalDetailsContainer = connect(mapStateToProps)(PersonalDetailsContainerComponent);
